// extracted by mini-css-extract-plugin
export var disabled = "_rx-0";